import { useQuery } from '@tanstack/react-query';
import { ICurrentOrLegacyReport } from '@opengov/reporting-types';
import { getCurrentOrLegacyReportsByEntityId } from '@opengov/reporting-legacy-module';

import { useToast } from '../../../../stories/components/Toast/context/useToast.context';
import { embedPickerQueryKeys, ReportsKeyParams } from './embedPickerQueryKeys';

export type UseReportsForEntityParams = ReportsKeyParams | null;

export function useReportsForEntity(params: UseReportsForEntityParams) {
  const { toggleToast } = useToast();

  return useQuery<ICurrentOrLegacyReport[], Error>({
    queryKey: params
      ? embedPickerQueryKeys.reports(params)
      : ([...embedPickerQueryKeys.all, 'reports', 'disabled'] as const),
    queryFn: async () => {
      if (!params) throw new Error('Disabled');
      const result = await getCurrentOrLegacyReportsByEntityId({
        entityId: params.entityId,
        includeAccountSummaryReports: params.includeAccountSummaryReports,
        includeMultiDatasetReports: params.includeMultiDatasetReports
      });
      return result as ICurrentOrLegacyReport[];
    },
    enabled: params !== null,
    staleTime: 5 * 60 * 1000,
    onError: () => {
      toggleToast({ title: 'Could not load reports', severity: 'error' });
    }
  });
}
